module.exports = __webpack_public_path__ + "static/media/Asma_Jahangir.60bdd208.jpg";